import { WarningCircle, X } from '@phosphor-icons/react';
import AppLink from '@/components/AppLink/AppLink';
import type { ErrorToastRecord } from '@/context/ErrorToastContext';

interface ErrorToastItemProps {
  error: ErrorToastRecord;
  onDismiss: (id: string) => void;
}

export function ErrorToastItem({ error, onDismiss }: ErrorToastItemProps) {
  const isWarning = error.severity === 'warning';

  return (
    <div
      role="alert"
      className={`animate-in fade-in slide-in-from-top-4 pointer-events-auto flex gap-3 rounded-2xl border p-4 shadow-lg duration-fast ${
        isWarning
          ? 'border-notice-warning-border bg-notice-warning'
          : 'border-glyph-critical/20 bg-glyph-critical/10'
      }`}
    >
      <WarningCircle
        className={`mt-0.5 size-5 shrink-0 ${isWarning ? 'text-notice-warning-color' : 'text-glyph-critical'}`}
        aria-hidden
      />
      <div className="min-w-0 flex-1">
        {error.title ? (
          <p
            className={`text-sm font-semibold ${isWarning ? 'text-notice-warning-color' : 'text-glyph-critical'}`}
          >
            {error.title}
          </p>
        ) : null}
        <p className="text-sm text-glyph-secondary">{error.message}</p>
        <p className="mt-2 text-xs text-glyph-secondary">
          <AppLink to="/contact-us" className="underline">
            Contact us
          </AppLink>{' '}
          if this keeps happening.
        </p>
      </div>
      <button
        type="button"
        className="shrink-0 rounded-md p-1 text-glyph-secondary hover:text-glyph-primary"
        aria-label="Dismiss error"
        onClick={() => onDismiss(error.id)}
      >
        <X className="size-4" aria-hidden />
      </button>
    </div>
  );
}
